import React, {useCallback, useEffect, useRef, useState} from 'react';
import {Button, VStack, Text, Box, Icon, Badge, HStack} from "@chakra-ui/react";
import {Check} from 'lucide-react';
import objectUtil from "@/utils/objectUtil";

export const CheckboxMultiSelect = ({
                                        items,
                                        getSelectedText,
                                        selectedItems,
                                        onChange,
                                        placeholder,
                                        variant = 'colorful',
                                        dropdownProps = {},
                                        ...props
                                    }) => {
    /** Allows to forbid first state of selectedItems triggering onChange */
    const [state, setState] = useState(0);
    const [_selectedItems, _setSelectedItems] = useState(selectedItems ?? []);
    const [isOpen, setIsOpen] = useState(false);
    const id = `checkbox-multiselect-${Date.now()}`;
    const containerRef = useRef();

    useEffect(() => {
        const clickListener = (event) => {
            if (containerRef?.current && !containerRef.current.contains(event.target)) {
                setIsOpen(() => false);
            }
        }

        window.addEventListener('click', clickListener)

        return () => {
            window.removeEventListener('click', clickListener);
        }
    }, []);

    const _onChange = (value, event) => {
        event.stopPropagation();
        _setSelectedItems(prevState => objectUtil.toggleElement([...prevState], value));
    }

    useEffect(() => {
        if (state === 0) {
            setState(() => 1)
        } else {
            onChange(_selectedItems);
        }
    }, [_selectedItems]);

    const isSelected = useCallback((value) => {
        return _selectedItems.includes(value);
    }, [_selectedItems])

    return <VStack position="relative" justify="center" ref={containerRef}>
        <Button bg={"secondary.500"} color={'white'} w="100%" variant={variant} onClick={() => setIsOpen(prevState => !prevState)} {...props}>
            {(_selectedItems?.length > 0) ? getSelectedText(_selectedItems) : placeholder}
        </Button>
        {isOpen &&
            <VStack onClick={(e) => e.stopPropagation()} maxH="50vh" overflowY="auto" overflowX="hidden" left="10%" w="80%" top="3rem" position="absolute" bg="white"
                    borderRadius="0 0 .5rem .5rem" gap="0" {...dropdownProps}>
                {items.map((e, i) => <Button
                    w="100%"
                    key={`multiselect-${id}-${i}`}
                    onClick={(event) => _onChange(e.value, event)}
                    bg={"white"}
                    color={"black"}
                >
                    <HStack flex={1}>
                        {
                            e?.color
                                ?
                                <Badge
                                    bg={e.color.background}
                                    color={e.color.text}
                                >
                                    {e.label}
                                </Badge>
                                :
                                <Text>{e.label}</Text>

                        }
                    </HStack>
                    <Box position="relative" ml="auto" maxH="1rem" maxW="1rem" minH="1rem" minW="1rem" marginLeft="1rem"
                         borderWidth=".15rem" borderRadius=".15rem" borderColor="gray.500">
                        {isSelected(e.value) && <Icon as={Check} position="absolute" w="100%" h="100%" left={0} color="secondary.500"/>}
                    </Box>
                </Button>)}
            </VStack>}
    </VStack>;
};

export default CheckboxMultiSelect;
